
import React from 'react';
import { Button, Modal, ModalBody, FormGroup, Input, Label } from 'reactstrap';

import UserService from '../../services/UserService';
import AlertModal from '../AlertModal/AlertModal';

import './RequestDetailUpdateModal.css';

const title = 'Update Detail';

class RequestDetailUpdateModal extends React.Component {

  state = {
    controls: {
      message: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null
      },
      keepMeLoggenIn: false,
      isRequestSubmitSuccessModalOpen: false,
      modalMessage: ''
    },
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    // this.handleValidation();
  }

  openDetailRequestSubmitSuccessAlert() {
    this.setState({ isRequestSubmitSuccessModalOpen: true });
  }

  sendUpdateDetailRequest = () => {
    const obj = {
      message: this.state.controls.message.value
    };
    UserService.sendUpdateDetailRequest(obj)
      .then(data => {
        const message = data.data.message;
        this.setState({ message });
        this.openDetailRequestSubmitSuccessAlert();
      })
      .catch(e => {
        console.error('error', e);
      });
  }


  closeModal = () => {
    this.setState({ isRequestSubmitSuccessModalOpen: false });
    this.props.closeModal(true);
  }

  render() {
    const { controls } = this.state;
    const { message } = controls;

    return (
      <div>
        <AlertModal
          show={this.state.isRequestSubmitSuccessModalOpen}
          closeModal={this.closeModal}
          title={title}
          msg={this.state.message}
          buttons={null}
          child={null}
        />
        <Modal id="request-detail-update-modal" isOpen={this.props.show} toggle={this.props.closeModal} centered>
          {/* <ModalHeader toggle={this.toggle} >REQUEST TO EDIT DETAILS</ModalHeader> */}
          <ModalBody>
            <FormGroup className="margin-top-10">
              <Label for="password" className="request-details">Request Details</Label>
              <Input
                type="textarea"
                name="message"
                id="message"
                placeholder="Tell us what you want to edit with reason. We will verify details and update database soon. We expect this to
                            complete in a few days however we will try it as soon as possible."
                value={message.value}
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <div style={{ textAlign: 'right' }}>
              <Button className="mb-1 mr-1 btn-pill Rectangle-button cancel-button" onClick={this.props.closeModal} color="dark">Cancel</Button>
              <Button className="mb-1 mr-1 btn-pill Rectangle-button send-button" onClick={this.sendUpdateDetailRequest} color="warning">Send</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default RequestDetailUpdateModal; 